import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AtendimentoSolicitacaoService } from '../../../../../services/atendimento-solicitacao.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HubConnection } from '@microsoft/signalr';
import { EquipeService } from '../../../../../services/equipe.service';
import { AdicionaContatoComponent } from './adiciona-contato/adiciona-contato.component';
import { ClienteFormularioContatoComponent } from '../../../cadastros/cadastro-cliente/cliente-formulario-contato/cliente-formulario-contato.component';
import { PaginaErroComponent } from '../../../componetes-comum/pagina-erro/pagina-erro.component';
import { ContatoEmpresaService } from '../../../../../services/contato-empresa.service';
import { PesquisaComponent } from '../../../componetes-comum/pesquisa/pesquisa.component';

@Component({
  selector: 'app-troca-fila-chat',
  templateUrl: './troca-fila-chat.component.html',
})
export class TrocaFilaChatComponent implements OnInit {

  dados
  SelectEquipes = []
  public tabelaContatos = [];
  formTroca: FormGroup;
  Empresa: any;
  Contato

  constructor(@Inject(MAT_DIALOG_DATA) data,
    public atendimentoSolicitacaoService: AtendimentoSolicitacaoService,
    public formBuilder: FormBuilder,
    public matDialogRef: MatDialogRef<TrocaFilaChatComponent>,
    private equipeService: EquipeService,
    private dialog: MatDialog,
    private contatoEmpresaService: ContatoEmpresaService) {

    this.formTroca = formBuilder.group({
      novaEquipe: [],
      Empresa: [],
      RazaoSocial: [],
      idEmpresa: [0]
    })
    this.dados = data
    console.log(data)
    this.equipeService.getEquipeChat()
      .toPromise()
      .then(response => {
        this.SelectEquipes = response.filter(item => item.idEquipe !== 98)
        // response.forEach(item => {
        //   if(item.idOpcaoApp != null){
        //     this.SelectDepartamento.push(item)
        //   }
        // })
        // this.SelectDepartamento.unshift('')
      })
  }

  ngOnInit(): void {
  }

  async confirmaTroca() {
    if (this.dados.User.nomeCliente != null) {
      let hubFila: HubConnection = this.dados.connectionFila
      let hubChat: HubConnection = this.dados.connectionChat
      await hubFila.invoke("SetAlteraFilaAtendimento", this.dados.idUserChat,
        this.dados.antigoGrupoName,
        this.formTroca.value.novaEquipe.idEquipe.toString())
        .then(response => {
          console.log(response)
          if (response != 200) {
            alert(response)
          }
          else {
            this.matDialogRef.close(this.formTroca.value.novaEquipe);
          }
        })
    }
    else {

      await this.gravar()

      let hubFila: HubConnection = this.dados.connectionFila
      let hubChat: HubConnection = this.dados.connectionChat
      await hubFila.invoke("SetAlteraFilaAtendimento", this.dados.idUserChat,
        this.dados.antigoGrupoName,
        this.formTroca.value.novaEquipe.idEquipe.toString())
        .then(resposta => {
          if (resposta != 200) {

            alert(resposta)
          }
          else {
            this.matDialogRef.close(this.formTroca.value.novaEquipe);
          }
        })

      // Código descontinuado em que o cliente precisava preencher os dados do contato manualmente
      // this.dialog.open(ClienteFormularioContatoComponent, {data: 'Chat'})
      //   .afterClosed()
      //   .subscribe(async response => {
      //     if(response){

      //     this.tabelaContatos.push(response)
      //     this.tabelaContatos = [...this.tabelaContatos]
      //     await this.gravar()

      //     
      //     }
      //   })
    }
  }

  formataObjContato(body) {
    let objContato = {
      Id: 0,
      Nome: body.NomeUsuarioWpp,
      Email: '',
      TelefonePrincipal: body.Telefone,
      TelefoneSecundario: '',
      PosicaoFuncional: '',
      Aniversario: '',
      idEmpresa: this.Empresa.Id
    }

    console.log(objContato)
    return objContato
  }

  //MÉTODO PARA GRAVAR O CONTATO DA EMPRESA
  async gravar() {

    // this.formataObjContato(this.dados.User)
    if (this.verifica()) {


      this.contatoEmpresaService.gravarContato([this.formataObjContato(this.dados.User)]).toPromise()
        .then(
          response => {
            this.abrirPaginaErro(response, "sistema")

            if (response[0].Codigo == "CRM00001") {

              this.limparCampos()
            }
          }
        )
        .catch(
          error => {
            this.abrirPaginaErro(error, "erro")
          }
        )
    }
  }

  limparCampos() {
  }

  //METODO PARA REALIZAR A PESQUISA
  buscarEmpresa() {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      componente: "EmpresaCliente",
      condicaoQuery: `EmpresaCliente.Status <> 'Inativo'`
    }

    this.dialog.open(PesquisaComponent, dialogConfig).afterClosed()
      .subscribe(
        response => {
          if (response) {
            this.contatoEmpresaService.get(response.Id).toPromise()
              .then(
                empresa => {
                  this.Empresa = empresa[0]
                  this.preencherEmpresa(empresa[0])
                }
              )
          }
        }
      )
  }

  // PREENCHE O FORMULARIO COM O NOME DA EMPRESA SELECIONADA NA PESQUISA

  preencherEmpresa(empresa) {

    this.formTroca.patchValue({
      RazaoSocial: empresa.RazaoSocial
    })
    this.tabelaContatos = [...empresa.ListaContatos]
  }

  verifica() {

    let validacao = true

    if (this.formTroca.get('RazaoSocial').status == "INVALID") {
      validacao = false
      //CHAMA MSG ERRO
      this.abrirPaginaErro('Insira uma empresa', 'interno');
    }
    return validacao
  }

  // PÁGINA DE MENSAGENS
  public abrirPaginaErro(mensagem, tipo) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      mensagem: mensagem,
      tipo: tipo
    };

    this.dialog.open(PaginaErroComponent, dialogConfig);
  }
}
